import { DepositLimitPeriodInterval } from "@finbackoffice/enums";

export function getFormattedDepositLimitPeriod(period: DepositLimitPeriodInterval) {
    switch (period) {
        case DepositLimitPeriodInterval.DAY: {
            return "daily";
        }
        case DepositLimitPeriodInterval.WEEK: {
            return "weekly";
        }
        case DepositLimitPeriodInterval.MONTH: {
            return "monthly";
        }
    }
    return "no-restriction";
}
